import { Component, OnInit,Output,EventEmitter } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-level1menu',
  templateUrl: './level1menu.component.html',
  styleUrls: ['./level1menu.component.css']
})
export class Level1menuComponent implements OnInit {

  @Output() change = new EventEmitter();
  menuList:any;
  selectedItem:any;

  constructor(private router: Router) { }

  ngOnInit() {

    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    
    let selectedMenuId=localStorage.getItem('selectedMenu');
    if(selectedMenuId !=null && selectedMenuId != '' && typeof(selectedMenuId)!=undefined)
      this.selectedItem=selectedMenuId;
    else{
      if(this.menuList.length!=0)
        this.selectedItem=this.menuList[0].KM_MenuId;
    }  
  }

  listClick(event, newValue) {
    localStorage.setItem('selectedMenu',newValue);
    this.selectedItem = newValue;  
}
  Logout(){
    localStorage.clear();
    this.change.emit(true);
    this.router.navigate(['/main']);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/level1menu/level1menu.component.ts